import React, { useState } from "react";

import MobileActionHeader from "../../../components/UI/headingsUI/MobileActionHeader";
import ListTableContent from "./ListTableContent";
import useImageUrl from "../../../CustomHooks/useImageUrl";
import useGetData from "../../../CustomHooks/useAxios/useGetData";
import { SINGLE_UPLOADED_SHEET } from "../../../api/allApi_List";
import SheetView from "../../../components/UI/viewDialogs/expense/SheetView";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import FilterSearch from "../../../components/common/FilterSearch";
import UsePermissionsClaim from "../../../CustomHooks/UsePermissionsClaim";

const UploadedSheetList = ({ navigate }) => {
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const { data, isLoaded, error, getData, setIsLoaded, setData } =
    useGetData();
  const { getImageUrl } = useImageUrl();
  const { checkPermission } = UsePermissionsClaim();
  const permAddSheet = checkPermission("add_sheets");

  const handleDownloadSheet = (sheetUrl) => {
    const urlSheet = getImageUrl(sheetUrl);
    // Validate image URL (optional)
    if (!urlSheet || !urlSheet.startsWith("https")) {
      console.error(
        'Invalid image URL. Please provide a valid URL starting with "http" or "https".'
      );
      return;
    }

    // Create anchor element and set attributes
    const link = document.createElement("a");
    link.href = urlSheet;
    link.download = "urlSheet.split(" / ").pop()"; // Get filename from URL
    link.click();
  };

  const handleSheetView = (dataId) => {
    setViewDialogOpen(true);
    getData(SINGLE_UPLOADED_SHEET + dataId);
  };

  const handleCloseViewDialog = () => {
    setIsLoaded(false);
    setViewDialogOpen(false);
    setData({});
  };
  return (
    <>
      <MobileActionHeader
        title="Uploaded Expense Sheets"
        navigate={"/sheet/add"}
        btnText={permAddSheet ? "Upload Sheet" : undefined}
      />
      <FilterSearch
        searchCategories={uploadSheetSearch}
        addBtnNavigation={"/sheet/add"}
        addBtnText={permAddSheet ? "Upload Sheet" : undefined}
      />

      <ListTableContent
        handleDownloadSheet={handleDownloadSheet}
        handleSheetView={handleSheetView}
      />
      {viewDialogOpen && !error ? (
        <SheetView
          viewDetails={data}
          isLoaded={isLoaded}
          error={error}
          closeDialog={handleCloseViewDialog}
        />
      ) : error ? (
        <DialogBox title="Error" message={handleErrMessage(error)} />
      ) : (
        ""
      )}
    </>
  );
};

export default UploadedSheetList;


const uploadSheetSearch = {
  user: ["createdBy", "fullName"],
};